import axios from '@/extensions/axios'

let getNewPageForApi = (state) => {
  let newPage = {
    ...state.newPage,
    groups: state.newPage.group ? [state.newPage.group.id] : [],
    content: undefined
  }

  if (!newPage.published_at) {
    newPage.published_at = null
  }

  return newPage
}

let getNewPageContentForApi = (state) => {
  let components = []
  if (state.newPage.content.content) {
    try {
      components = JSON.parse(state.newPage.content.content)
    } catch (e) {
      throw new Error('Invalid JSON!')
    }
  } else {
    components = state.newPage.content.components
  }

  let newContent = {
    ...state.newPage.content,
    layout_id: state.newPage.content.layout ? state.newPage.content.layout.id : undefined,
    language_id: state.newPage.content.language ? state.newPage.content.language.id : state.newPage.content.language_id,
    content: components,
    components: undefined
  }

  if (!newContent.published_at) {
    newContent.published_at = null
  }

  return newContent
}

// Page actions
const actions = {
  create ({ commit, state, rootState }, page = void 0) {
    page = page || getNewPageForApi(state)

    return axios.post('sites/' + rootState.site.active.id + '/pages', page)
      .then(({ data }) => {
        commit('UPDATE_NEW', { key: 'id', value: data.id })
        const pageContents = page.contents || [getNewPageContentForApi(state)]
        pageContents.forEach(pageContent => {
          axios.post('pages/' + data.id + '/content', pageContent)
        })
      })
  },

  save ({ commit, state, rootState }, page = void 0) {
    page = page || getNewPageForApi(state)

    return axios.put('pages/' + page.id, page)
      .then(() => {
        const pageContents = page.contents || [getNewPageContentForApi(state)]
        pageContents.forEach(pageContent => {
          axios.post('pages/' + page.id + '/content', pageContent)
        })
      })
  },

  remove ({ commit }, key) {
    // TODO add language
    return axios.delete('pages/' + key).then(() => {
      commit('REMOVE', key)
    })
  },

  get ({ commit, rootState }, queryParams) {
    return axios.get('sites/' + rootState.site.active.id + '/pages', {
      params: queryParams
    }).then(request => {
      commit('SET', request)
      return request
    })
  },

  getById ({ commit, state }, { id, languageId }) {
    return axios.get('pages/' + id + '/' + languageId).then((request) => {
      if (!request.data.content) {
        request.data.languageId = languageId
      }

      commit('SET_NEW', request.data)
      return request
    })
  },

  getAll ({ rootState }) {
    // TODO 1000 is not all but close enough for now
    return axios.get('sites/' + rootState.site.active.id + '/pages?per-page=1000')
      .then(({ data }) => {
        return data
      })
  },

  getRevisions ({ commit, state }, queryParams) {
    return axios.get('pages/' + state.newPage.id + '/' + state.newPage.content.language_id + '/revisions', {
      params: queryParams
    }).then(request => {
      commit('SET_REVISIONS', request)
      return request
    })
  }
}

export default actions
